import { Faq, KnowledgeHubResource } from "@/types/dto/category.dto";
import { ActivitySquare } from "lucide-react";
import { MutableRefObject, ReactNode, useEffect, useRef, useState } from "react";
import KnowledgeHubAndFAQTabs from "./sub-tabs/knowledge-hub-and-faq-tabs";
import cn from "@/lib/cn";

// TODO (zeekhug): Move to a shared directory. This probably can also be used as `ReadMore` for posts
export const ReadMore = (props: {
	maxHeight: number;
	children: (args: { ref: MutableRefObject<HTMLDivElement | null> }) => ReactNode;
}) => {
	const [showReadMore, setShowReadMore] = useState<boolean>(false);
	const divRef = useRef<HTMLDivElement | null>(null);
	const maxDivHeightinPixels = 128;

	useEffect(() => {
		if (divRef.current) {
			const currentHeight = divRef.current.offsetHeight;
			if (currentHeight > maxDivHeightinPixels) {
				if (currentHeight > props.maxHeight) {
					if (currentHeight > props.maxHeight) {
						setShowReadMore(true);
					} else {
						setShowReadMore(false);
					}
				}
			}
		}
	}, [divRef.current?.offsetHeight, props.maxHeight]);

	return (
		<>
			<div>
				<div
					// Using style to be able to use single variable for height
					ref={divRef}
					style={showReadMore ? { maxHeight: `${props.maxHeight}px` } : {}}
					className={cn(
						"relative flex  flex-col overflow-y-hidden text-gray-600",
						showReadMore &&
							"after:absolute after:bottom-0 after:left-0 after:right-0 after:h-14 after:bg-gradient-to-b after:from-transparent after:via-white/70 after:to-white after:ease-linear after:content-['']"
					)}
				>
					{props.children({ ref: divRef })}
				</div>
				<button
					onClick={() => setShowReadMore((prev) => !prev)}
					className="font-medium text-brand-primary"
				>
					Show {showReadMore ? "more" : "less"}
				</button>
			</div>
		</>
	);
};

type BuyersGuideTabProps = {
	title?: string;
	faqs?: Faq[];
	knowledgeHubResources?: KnowledgeHubResource[];
	content: string;
};

const BuyersGuideTab = ({ title, ...props }: BuyersGuideTabProps) => {
	return (
		<>
			<div className="my-8 flex flex-col gap-4 rounded-xl bg-white p-6 shadow md:p-12">
				<div className="flex flex-col items-start gap-4 lg:flex-row lg:items-center">
					<div className="flex items-center justify-center rounded-2xl bg-gradient-to-br from-brand-primary/5 via-brand-primary to-brand-primary p-4">
						<ActivitySquare className="h-8 w-8 text-white" />
					</div>

					<h1 className="text-xl font-bold leading-snug lg:text-3xl">{title}</h1>
				</div>

				<ReadMore maxHeight={128}>
					{({ ref }) => <div ref={ref} dangerouslySetInnerHTML={{ __html: props.content }}></div>}
				</ReadMore>
			</div>

			<KnowledgeHubAndFAQTabs
				faqs={props.faqs}
				knowledgeHubResources={props.knowledgeHubResources}
			/>
		</>
	);
};

export default BuyersGuideTab;
